import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import Icon from 'flarum/common/components/Icon';
import abbreviateNumber from 'flarum/common/utils/abbreviateNumber';
import extractText from 'flarum/common/utils/extractText';
import DiscussionListItem from 'flarum/forum/components/DiscussionListItem';

// What fof/discussion-views adds to the model.

/**
 * fof/discussion-views puts the view count in a discussion's info row and
 * pins it under the reply count, where it sat askew beside it (and made a
 * second pill on phones). On wider screens it is a second line of core's
 * stats column instead, icon under icon; on phones the stats column is the
 * reply pill alone and fof's count stays in the info row
 * (discussion-views.less).
 */
export default function discussionViews() {
  extend(DiscussionListItem.prototype, 'statsItems', function (items) {
    const views = this.attrs.discussion.views?.() || 0;
    const label = extractText(app.translator.trans('bimmerdock-theme.forum.discussion_views.count', {
      count: views
    }));

    // The markup of core's reply count (DiscussionListItemStatsItem, which
    // the export registry doesn't hand out by name).
    items.add('views', m("span", {
      className: "DiscussionListItem-stats-item DiscussionListItem-views"
    }, m("span", {
      className: "DiscussionListItem-stats-item-icon"
    }, m(Icon, {
      name: "far fa-eye"
    })), m("span", {
      className: "DiscussionListItem-stats-item-label"
    }, m("span", {
      "aria-hidden": "true"
    }, abbreviateNumber(views)), m("span", {
      className: "visually-hidden"
    }, label))), 60);
  });
}